export const getReviewCounter = (title) => {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 0);
    const diff = now - startOfYear;
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);

    const generateCounter = (num) => {
        return num + dayOfYear;
    }

    if (title?.toLowerCase().includes('supreme')) return generateCounter(13555);
    if (title?.toLowerCase().includes('elite')) return generateCounter(10123);
    if (title?.toLowerCase().includes('5 layer')) return generateCounter(6123);
    if (title?.toLowerCase().includes('proguard')) return generateCounter(2123);
    return generateCounter(13555);
}

export const getReviewCounterForCustomProducts = () => {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 0);
    const diff = now - startOfYear;
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);

    const generateCounter = (num) => {
        return num + dayOfYear;
    }

    return generateCounter(13555);
}